import React from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button';
import '../common-content-btn/BtnContent.css';

const BtnIconContent = React.memo((props) => {
    const {
        startIcon,
        color,
        click,
        size,
        children,
        ...rest   // 👈 capture all extra props (draggable, onDragStart, etc.)
    } = props;

    return (
        <Button
            disabled={props?.disabled}
            endIcon={startIcon}
            startIcon={startIcon}
            className='text-capitalize'
            variant="contained"
            color={color}
            onClick={click}
            size={size}
            {...rest}   // 👈 forward them here
        >
            {children}
        </Button>
    );
});

BtnIconContent.propTypes = {
    startIcon : PropTypes.node,
    color : PropTypes.string,
    click : PropTypes.func,
    size : PropTypes.string,
    children : PropTypes.any
}

export default BtnIconContent